module.exports = __webpack_public_path__ + "media/images/curriculum_1-db6136c4bbe36b37c54dbfe5b5fe5ce8.png";